import React from "react";
import { Card, Col, Nav, Row, Tab } from "react-bootstrap";
import SimpleBar from "simplebar-react";

// Components
import ProfileTab from "./tabs/ProfileTab";
import MultimediaTab from "./tabs/MultimediaTab";
import FilesTab from "./tabs/FilesTab";
import LinksTab from "./tabs/LinksTab";
import NotesTab from "./tabs/NotesTab";

/**
 * Barra lateral del chat
 *
 * @param {Function} closeSidebar - Función para cerrar la barra lateral
 * @returns {JSX.Element} Componente de React
 */
const ChatSidebar = ({ closeSidebar }) => {
  // Contenido de las pestañas
  const tabContents = [
    {
      id: "1",
      title: "Perfil",
      element: <ProfileTab />,
    },
    {
      id: "2",
      title: "Multimedia",
      element: <MultimediaTab />,
    },
    {
      id: "3",
      title: "Archivos",
      element: <FilesTab />,
    },
    {
      id: "4",
      title: "Enlaces",
      element: <LinksTab />,
    },
    {
      id: "5",
      title: "Notas",
      element: <NotesTab />,
    },
  ];

  return (
    <Card
      className="position-absolute border rounded end-0 top-0"
      style={{
        width: "450px",
        height: "100%",
        zIndex: "200",
      }}
    >
      <Card.Header className="bg-light">
        <div className="d-flex align-items-center">
          <i
            className="cursor-pointer mdi mdi-close text-secondary h3 m-0"
            onClick={closeSidebar}
          />
        </div>
      </Card.Header>

      <Card.Body className="bg-light">
        <Row>
          <Tab.Container defaultActiveKey="Perfil">
            {/* Barra de pestañas */}
            <Col
              sm={4}
              className="border-end border-2 mb-2 mb-sm-0"
              style={{
                height: "calc(100vh - 220px)",
              }}
            >
              <Nav variant="pills" className="flex-column">
                {tabContents.map((tab, index) => {
                  return (
                    <Nav.Item key={index}>
                      <Nav.Link to="#" eventKey={tab.title}>
                        <span>{tab.title}</span>
                      </Nav.Link>
                    </Nav.Item>
                  );
                })}
              </Nav>
            </Col>

            {/* Contenido de las pestañas */}
            <Col sm={8}>
              <Tab.Content>
                {tabContents.map((tab, index) => {
                  return (
                    <Tab.Pane eventKey={tab.title} key={index}>
                      <SimpleBar
                        style={{
                          height: "calc(100vh - 220px)",
                          overflowY: "auto",
                        }}
                      >
                        {tab.element}
                      </SimpleBar>
                    </Tab.Pane>
                  );
                })}
              </Tab.Content>
            </Col>
          </Tab.Container>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ChatSidebar;
